export default __webpack_public_path__ + "static/media/java01.8b10025b.PNG";